<script>
import { onMount } from "svelte";
let activeChapter = 0;
let player;
let done = false;
function onYouTubeIframeAPIReady() {
        player = new YT.Player('player', {
          height: '390',
          width: '100%',
          videoId: 'q51FMbTOn_Q',
          cc_lang_pref: 'en',
          cc_load_policy: 1,
          color: 'white',
          modestbranding: 1,
          events: {
            'onReady': onPlayerReady,
            'onStateChange': onPlayerStateChange
          }
        });
      }

      // 4. The API will call this function when the video player is ready.
      function onPlayerReady(event) {
        // event.target.playVideo();
      }

      // 5. The API calls this function when the player's state changes.
      //    The function indicates that when playing a video (state=1),
      //    the player should play for six seconds and then stop.

      function onPlayerStateChange(event) {
        // if (event.data == YT.PlayerState.PLAYING && !done) {
        //   setTimeout(stopVideo, 6000);
        //   done = true;
        // }
      }
      function stopVideo() {
        player.stopVideo();
      }

      function seek(seconds, chapterNumber){
          player.playVideo();
          player.seekTo(seconds,true);
          activeChapter = chapterNumber;
      }
      


    onMount(() => {

        var tag = window.document.createElement('script');

      tag.src = "https://www.youtube.com/iframe_api";
      var firstScriptTag = window.document.getElementsByTagName('script')[0];
      firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);

      // 3. This function creates an <iframe> (and YouTube player)
      //    after the API code downloads.
      setTimeout(() => {
        onYouTubeIframeAPIReady();
      }, 2000);
        
      });
</script>

<div class="watchblock">
  <div class="title condensed bold text-center">
    <h2 class="pb-3" id="watch">Watch</h2>
  </div>
  <div class="videoblock">
    <div class="row">
      <div class="col-md-9">
        <div class="video">
            <div id="player"></div>
            <div class="video-text">
              <div class="video-text-icon">
                <i class='bx bx-info-circle'></i>
              </div>
              <div class="video-text-text">
                There are subtitles available in English, German and Swedish! Select the language you prefer in the player's subtitle menu.
              </div>
            </div>
            
        </div>
      </div>
      <div class="col-md-3">
        <div class="chapters condensed">
          <div class="chapters-title bold pb-3">Chapters</div>
          <ol class="bold">
            <li on:click={() => seek(400, 1)} class="{activeChapter === 1 ? 'active-chapter' : 'chapter'}">Climate</li>
            <li on:click={() => seek(1080, 2)} class="{activeChapter === 2 ? 'active-chapter' : 'chapter'}">Biodiversity</li>
            <li on:click={() => seek(2113, 3)} class="{activeChapter === 3 ? 'active-chapter' : 'chapter'}">Ecosystem services</li>
            <li on:click={() => seek(2300, 4)} class="{activeChapter === 4 ? 'active-chapter' : 'chapter'}">Economy</li>
            <li on:click={() => seek(2519, 5)} class="{activeChapter === 5 ? 'active-chapter' : 'chapter'}">People and Forest</li>
            <li on:click={() => seek(2640, 6)} class="{activeChapter === 6 ? 'active-chapter' : 'chapter'}">More of everything?</li>
            <li on:click={() => seek(2867, 7)} class="{activeChapter === 7 ? 'active-chapter' : 'chapter'}">Planting</li>
            <li on:click={() => seek(2970, 8)} class="{activeChapter === 8 ? 'active-chapter' : 'chapter'}">Exploiting science</li>
          </ol>
        </div>
      </div>
    </div>
  </div>
</div>

<style>
  .watchblock {
    background: #b4b4b4;
    padding: 2rem 4rem;
  }
  .chapters,
  .title {
    color: #ffffff;
  }
  .chapters-title {
    font-size: 1.2rem;
    margin-left: 1.2rem;
  }
  li {
    padding: 0.4rem 0rem;
    cursor: pointer;
  }
  li.chapter {
    color: #ffffff;
  }
  li:hover {
      color: #497c81;
  }
  li.active-chapter {
    color: #497c81;
  }
  .video-text {
    display: flex;
    align-items:center;
    color:white;
  }
  .video-text-icon {
    margin-right: 7px;
  }

  @media (max-width: 575.98px) {
    .watchblock {
      background: #b4b4b4;
      padding: 2rem 1rem;
    }

    .pb-3 {
      padding-bottom: 0rem;
    }
  }
</style>
